import { abyssColors } from '@/theme/colors';
import { IconButton, styled as muiStyled, Stack } from '@mui/material';

interface AttachmentCardProps {
  isPdf?: boolean;
  isVideo?: boolean;
  isImage?: boolean;
  cardHeight?: string;
}

export const StyledRemoveButton = muiStyled(IconButton)({
  position: 'absolute',
  top: -6,
  right: -6,
  color: 'white',
  backgroundColor: abyssColors.error[500],
  '&:hover': {
    backgroundColor: 'darkred',
  },
  borderRadius: '50%',
  width: 22,
  height: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const AttachmentCard = muiStyled(Stack)<AttachmentCardProps>(
  ({ isPdf, isVideo, cardHeight = '8rem' }) => ({
    ...(isPdf || isVideo
      ? {
          border: 'none',
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%' height='100%' fill='none' stroke='%23B8CADD' stroke-width='1' stroke-dasharray='2 2' rx='4' ry='4'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
        }
      : {
          border: `0.1rem solid ${abyssColors.primary[200]}`,
        }),
    borderRadius: '0.4rem',
    aspectRatio: '1 / 1',
    height: cardHeight,
    width: cardHeight,
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.8,
    },
    transition: 'opacity 0.2s ease-in-out',
  })
);

export const FileOptions = muiStyled(IconButton)<AttachmentCardProps & { inline?: boolean }>(
  ({ isPdf, isVideo, inline }) => ({
    position: inline ? 'static' : 'absolute',
    top: inline ? undefined : '0.6rem',
    right: inline ? undefined : '0.6rem',
    width: '1.6rem',
    height: '1.6rem',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    aspectRatio: '1 / 1',
    border: `0.1rem solid ${abyssColors.primary[500]}`,
    background: isPdf || isVideo ? 'transparent' : abyssColors.neutral[50],
    padding: 0,
  })
);
